<template>
  <div id="dc_mypage">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>ユーザ管理</h2>
            <dd-account-manaeger />
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcAccountManager from '../components/user/DcAccountManager'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-account-manaeger': DcAccountManager,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcUserManager',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'dcUserManager', key: 'dcUserManager', title: 'ユーザ管理', route: 'DcUserManager'}
      ]
    }
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUserManager.vue